module.exports = __webpack_public_path__ + "img/ztly.19972fef.jpg";